<template>
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="mini" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单号">
          <el-input size="mini" style="width: 130px" v-model="searchForm.orderNo" clearable
                    placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="买家姓名">
          <el-input size="mini" style="width: 130px" v-model="searchForm.userName" clearable
                    placeholder="请输入买家姓名"></el-input>
        </el-form-item>
        <el-form-item label="收货手机">
          <el-input size="mini" style="width: 130px" v-model="searchForm.receivePhone" clearable
                    placeholder="请输入收货手机"></el-input>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input size="mini" style="width: 130px" v-model="searchForm.productName" clearable
                    placeholder="请输入产品名称"></el-input>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input size="mini" style="width: 130px" v-model="searchForm.expressNo" clearable
                    placeholder="请输入物流单号"></el-input>
        </el-form-item>

        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              style="width: 240px"
              clearable
              size="mini"
              v-model="searchForm.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="success" @click="onExport" v-auth="'/order/operate/export'">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="success" @click="onProductExport" v-auth="'/order/operate/export'">按商品导出
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部订单" name="all"></el-tab-pane>
          <el-tab-pane :label="'未付款(' + order_count.payment + ')'" name="payment"></el-tab-pane>
          <el-tab-pane :label="'待发货(' + order_count.delivery + ')'" name="delivery"></el-tab-pane>
          <el-tab-pane :label="'待收货(' + order_count.received + ')'" name="received"></el-tab-pane>
          <el-tab-pane label="待评价" name="comment"></el-tab-pane>
          <el-tab-pane label="已完成" name="six"></el-tab-pane>
          <el-tab-pane label="已取消" name="cancel"></el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData.data" :span-method="arraySpanMethod" border style="width: 100%"
                  v-loading="loading">
          <el-table-column label="订单信息" min-width="500">
            <template slot-scope="scope">
              <div class="order-code" v-if="scope.row.isTopRow">
                <span class="state-text"
                      :class="{ 'state-text-red': scope.row.orderSource != 10 }">{{ scope.row.orderSourceText }}</span>
                <span class="c_main">订单号：{{ scope.row.orderNo }}</span>
                <span class="pl16">下单时间：{{ scope.row.createTime }}</span>
                <span class="pl16">订单类型：{{ scope.row.orderSourceText + '订单' }}</span>
                <span class="pl16">结算状态：{{ scope.row.isSettled === 0 ? '未出账' : '已结算' }}</span>

                <span class="pl16" v-if="scope.row.agentName">分销商：{{ scope.row.agentName }}</span>
                <!--是否取消申请中-->
                <span class="pl16" v-if="scope.row.orderStatus === 21"><el-tag effect="dark"
                                                                               size="mini">取消订单中</el-tag></span>
                <span class="pl16"
                      v-if="scope.row.orderStatus === 21 && scope.row.cancelTime"> 申请时间：{{
                    scope.row.cancelTime
                  }}</span>
                <span class="pl16"
                      v-if="scope.row.orderStatus === 10 && scope.row.deliveryStatus===20 && scope.row.receiptStatus===10 && scope.row.logisticsStatus === 1"><el-tag
                  effect="dark"
                  type="danger"
                  size="mini">异常订单</el-tag></span>

                <span class="pl16"
                      v-if="scope.row.wdtUploadStatus === 3 && scope.row.orderStatus === 10 &&  scope.row.deliveryStatus===10  && scope.row.payStatus===20"><el-tag
                  effect="dark"
                  type="warning"
                  size="mini">延迟推送中...</el-tag></span>

                <span class="pl16"
                      v-if="scope.row.orderStatus == 10 && scope.row.deliveryStatus==10 && scope.row.payStatus == 20 && scope.row.isDeliveryTimeout == 1">
                  <el-tag
                    effect="dark"
                    type="danger"
                    size="mini">发货超时中... </el-tag></span>
              </div>
              <template v-else>
                <div class="product-info" v-for="(item, index) in scope.row.productList" :key="index">
                  <div class="pic"><img v-img-url="item.imagePath" alt=""/></div>
                  <div class="info">
                    <div class="name gray3 product-name">
                      <span>{{ item.productName }}</span>
                    </div>
                    <div class="d-s-c">
                      <div class="gray9 pr16" v-if="item.productAttr">{{ item.productAttr }}</div>
                      <div class="orange pr16">￥ {{ item.productPrice }}</div>
                      <div class="gray3">x{{ item.totalNum }}</div>
                    </div>
                    <div class="orange" v-if="item.refund">{{ item.refund.type.text }}-{{
                        item.refund.status.text
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="orderPrice" align="center" label="订单金额" min-width="100">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="orange">{{ scope.row.orderPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" align="center" label="支付总价" min-width="120">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="orange">{{ scope.row.payPrice }}</div>
              <p class="gray9">(含运费：{{ scope.row.expressPrice }})</p>
              <p class="gray9"> {{ scope.row.payTypeText }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="agent_money" align="center" label="佣金金额" min-width="100">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="orange">{{ scope.row.agentMoney }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="买家" min-width="120">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div>{{ scope.row.nickname }}</div>
              <div class="gray9">{{ scope.row.mobile }}</div>
            </template>
          </el-table-column>

          <el-table-column label="交易状态" width="100px">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="table-btn-column">
                <div :style="{color:getShowStatusColor(scope.row)}">{{ scope.row.orderStatusText }}</div>
                <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/order/order/detail'">订单详情
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="95">
            <template slot-scope="scope" v-if="!scope.row.isTopRow">
              <div class="table-btn-column">
                <el-button
                  class="m-v-2"
                  v-if="scope.row.payStatus === 20 && scope.row.orderStatus === 10"
                  @click="cancelClick(scope.row)"
                  type="info"
                  size="small"
                  v-auth="'/order/operate/confirmCancel'"
                >
                  <div class="p-h-10 p-v-5">取消订单</div>
                </el-button>
                <el-button v-if="scope.row.orderStatus === 21" @click="onConfirmClick(scope.row)" type="primary"
                           size="small"
                           v-auth="'/order/operate/confirmCancel'">
                  <div class="p-h-10 p-v-5">订单审核</div>
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--处理-->
    <Cancel v-if="open_edit" :open_edit="open_edit" :order_no="order_no"
            @closeDialog="closeDialogFunc($event, 'edit')"></Cancel>

    <el-dialog title="审核订单" :visible.sync="dialogConfirm" width="30%">

      <p class="red pb16">
        当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。</p>
      <el-form size="small" :model="confirmForm">
        <el-form-item label="审核状态">
          <div>
            <el-radio v-model="confirmForm.isCancel" :label="1">同意</el-radio>
            <el-radio v-model="confirmForm.isCancel" :label="0">拒绝</el-radio>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogConfirm=false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmCancel">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import OrderApi from '@/api/order.js'
import qs from 'qs'
import {getCookie} from '@/utils/base.js'
import Cancel from './dialog/cancel.vue'

export default {
  components: {
    Cancel
  },
  props: {
    delivery: Number
  },
  data () {
    return {
      /*切换菜单*/
      activeName: 'all',
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        orderNo: '',
        createTime: '',
        userName: '',
        productName: '',
        expressNo: '',
        receivePhone: ''
      },

      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      order_no: '',
      dialogConfirm: false,
      confirmForm: {
        orderId: 0,
        isCancel: 1
      },
    }
  },
  created () {
    /*获取列表*/
    this.getData()
  },
  methods: {
    /*跨多列*/
    arraySpanMethod (row) {
      if (row.rowIndex % 2 === 0) {
        if (row.columnIndex === 0) {
          return [1, 8]
        }
      }
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick (tab, event) {
      let self = this
      self.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      let search = this.searchForm
      let Params = {}
      Params.dataType = self.activeName
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      if (search.createTime && search.createTime.length) {
        Params.startDate = search.createTime[0]
        Params.endDate = search.createTime[1]
      }

      if (search.userName) {
        Params.userName = search.userName
      }

      if (search.productName) {
        Params.productName = search.productName
      }

      if (search.receivePhone) {
        Params.receivePhone = search.receivePhone
      }

      if (search.expressNo) {
        Params.expressNo = search.expressNo
      }

      Params.orderNo = search.orderNo
      if (this.delivery) {
        Params.deliveryType = this.delivery
      }
      self.loading = true
      OrderApi.orderlist(Params, true)
        .then(res => {
          let list = []
          for (let i = 0; i < res.data.orderList.records.length; i++) {
            let item = res.data.orderList.records[i]
            let topitem = {
              orderNo: item.orderNo,
              createTime: item.createTime,
              orderSource: item.orderSource,
              orderSourceText: item.orderSourceText,
              isSettled: item.isSettled,
              orderStatus: item.orderStatus,
              isTopRow: true,
              suName: item.supplierName,
              agentName: item.agentShopName || item.agentName,
              cancelTime: item.cancelTime,
              deliveryStatus: item.deliveryStatus,
              receiptStatus: item.receiptStatus,
              logisticsStatus: item.logisticsStatus,
              wdtUploadStatus: item.wdtUploadStatus,
              payStatus: item.payStatus,
              isDeliveryTimeout: item.isDeliveryTimeout
            }
            list.push(topitem)
            list.push(item)
          }
          self.tableData.data = list
          self.totalDataNumber = res.data.orderList.total
          self.order_count = res.data.orderCount
          self.loading = false
        })
        .catch(error => {
        })
    },
    /*打开取消*/
    cancelClick (item) {
      this.order_no = item.orderNo
      this.open_edit = true
    },
    /*关闭弹窗*/
    closeDialogFunc (e, f) {
      if (f == 'edit') {
        this.open_edit = e.openDialog
        if (e.type == 'success') {
          this.getData()
        }
      }
    },
    /*打开添加*/
    addClick (row) {
      let self = this
      let params = row.orderId
      self.$router.push({
        path: '/order/order/Detail',
        query: {
          orderId: params
        }
      })
    },
    onConfirmClick (row) {
      this.confirmForm = {
        orderId: row.orderId,
        isCancel: 1
      }
      this.dialogConfirm = true
    },

    /*确认取消*/
    confirmCancel () {
      let self = this
      let param = self.confirmForm
      OrderApi.confirm(param, true)
        .then(data => {
          self.$message({
            message: '恭喜你，审核成功',
            type: 'success'
          })
          self.getData()
          self.dialogConfirm = false
        }).catch(error => {

      })
    },
    /*搜索查询*/
    onSubmit () {
      this.curPage = 1
      this.tableData = []
      this.getData()
    },
    onExport: function () {
      let self = this
      let search = this.searchForm
      let Params = {}
      Params.dataType = self.activeName
      Params.startDate = search.createTime[0]
      Params.endDate = search.createTime[1]
      Params.token = getCookie('token')

      window.location.href = process.env.BASE_API + 'shop/order/operate/export?' + qs.stringify(Params)
    },
    onProductExport: function () {
      let self = this
      let search = this.searchForm
      let Params = {}
      Params.dataType = self.activeName
      Params.startDate = search.createTime[0]
      Params.endDate = search.createTime[1]
      Params.token = getCookie('token')
      window.location.href = process.env.BASE_API + 'shop/order/operate/export/byproduct?' + qs.stringify(Params)
    },
    getShowStatusColor (row) {
      let text = ''
      let orderStatus = row.orderStatus
      let payStatus = row.payStatus
      let deliveryStatus = row.deliveryStatus
      if (orderStatus === 20) {
        return '#999999'
      }
      if (orderStatus === 30) {
        return '#333333'
      }

      if (payStatus === 10) {
        return '#FF453A'
      }

      if (deliveryStatus === 10) {
        return '#FF9500'
      }

      if (deliveryStatus === 20) {
        return '#FFCC00'
      }
      return text
    }
  }
}
</script>
<style lang="scss">
.product-info {
  padding: 5px;
  border-top: 1px solid #eeeeee;
}

.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}

.order-code .state-text-red {
  background: red;
}

.table-wrap .product-info:first-of-type {
  border-top: none;
}

.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/orderComponent.vue